'use strict';

exports.__esModule = true;
exports.default = getTheme;
var typography = {
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Droid Sans", "Helvetica Neue", sans-serif',
  fontSize: '16px'
};
var light = {
  typography: typography,
  colors: {
    textColor: '#424242',
    primaryTextColor: '#fff',
    primaryColor: '#0B6AFF',
    titleColor: '#424242',
    alertColor: '#d9534f'
  }
};
var dark = {
  typography: typography,
  colors: {
    textColor: '#fff',
    backgroundColor: '#212121',
    primaryTextColor: '#fff',
    primaryColor: '#2196F3',
    titleColor: '#fff',
    alertColor: '#d9534f',
    borderColor: '#666'
  }
};

function getTheme(preset) {
  if (preset === 'light') {
    return light;
  }

  return dark;
}